import React, {PropsWithChildren, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {useRouter} from 'next/router';
import {RootStoreType, useStore} from '@/store/root-store';
import {publicPages} from '@/utils/const';
import {getTokenFromCookies} from '@/api/common-utils';
import {NoSsr} from '../common-components';
import {SpinnerWrapper} from '@/components/common-components/v2/maps/universalLoader/styled';
import dynamic from 'next/dynamic';

const DynamicPublicLayout = dynamic(() => import('@/components/layoutV2/publicLayout/publicLayout').then(mod => mod.PublicLayout), {
  loading: () => <SpinnerWrapper/>,
  ssr: false,
});

const DynamicPrivateLayout = dynamic(() => import('@/components/layoutV2/privateLayout/privateLayout').then(mod => mod.PrivateLayout), {
  loading: () => <SpinnerWrapper/>,
  ssr: false,
});

type LayoutProps = PropsWithChildren<{
    pathname: string;
    store: RootStoreType;
}>;

const Layout = observer(({pathname, store, children}: LayoutProps) => {
  const {settings: {customer: {loadProfile, profile}}} = useStore('');
  let path = pathname;

  useEffect(() => {
    const token = getTokenFromCookies();
    if (!profile?.id && (token || path === '/pricing')) {
      loadProfile().catch(err => {
        console.error('Failed to load profile in Layout:', err);
      });
    }
  }, [profile?.id, path, loadProfile]);

  if (!pathname) {
    const router = useRouter();
    path = router.pathname;
  }


  if (publicPages.includes(path)) {
    return (
      <NoSsr>
        <DynamicPublicLayout store={store}>{children}</DynamicPublicLayout>
      </NoSsr>
    );
  } else {
    return (
      <NoSsr>
        <DynamicPrivateLayout store={store}>{children}</DynamicPrivateLayout>
      </NoSsr>
    );
  }
});

export default Layout;
